export default {
  namespaced: true,
  state: {
    period: {
      from: '',
      to: ''
    }
  },
  getters: {
    getPeriod (state) {
      return state.period
    }
  },
  mutations: {
    setPeriod (state, period) {
      state.period = period
    }
  }
}
